export default __webpack_public_path__ + "static/media/portfolio-5.754e7e56.jpg";